/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Agents_DescInputs */

const en_wc_why_agents_desc = /** @type {(inputs: Wc_Why_Agents_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every action is a command. The same commands drive the ribbon, a CLI, a JSON control channel and an MCP server.`)
};

/**
* | output |
* | --- |
* | "Every action is a command. The same commands drive the ribbon, a CLI, a JSON control channel and an MCP server." |
*
* @param {Wc_Why_Agents_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_agents_desc = /** @type {((inputs?: Wc_Why_Agents_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Agents_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_agents_desc(inputs)
});
export { wc_why_agents_desc as "wc.why.agents.desc" }